<p-confirmDialog
  [key]="confirmationKey"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '30vw' }"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>
